/**
 * moment stub — W5.1
 * utils/index.js (legacy) imports moment for date formatting.
 * This stub provides the minimal API used by that file.
 */
function moment(value, format) {
  let d;
  if (value && format) {
    // Basic ISO parse
    d = new Date(value);
  } else if (value) {
    d = new Date(value);
  } else {
    d = new Date();
  }

  const pad = (n) => String(n).padStart(2, '0');

  return {
    isValid: () => !isNaN(d.getTime()),
    year: () => d.getFullYear(),
    format: (fmt) => {
      if (!fmt) return d.toISOString();
      return fmt
        .replace('DD', pad(d.getDate()))
        .replace('MM', pad(d.getMonth() + 1))
        .replace('YYYY', d.getFullYear())
        .replace('HH', pad(d.getHours()))
        .replace('mm', pad(d.getMinutes()))
        .replace('ss', pad(d.getSeconds()));
    },
  };
}

moment.locale = () => {};
moment.isMoment = (v) => false;

export default moment;
